(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[90677],{

/***/ 25416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AffiliateOfferUrl; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/lib/shared/cookies.ts
var cookies = __webpack_require__(76309);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/index.ts + 19 modules
var api = __webpack_require__(21513);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/components/shared/affiliateOfferUrl/mobileIcon.tsx

const MobileIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        id: "Layer_2",
        viewBox: "0 0 16 22",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "Layer_1-2",
            fill: "#fff",
            d: "M2 12.25V20 2zM2 22c-.55 0-1.02-.2-1.41-.59S0 20.55 0 20V2C0 1.45.2.98.59.59S1.45 0 2 0h10c.55 0 1.02.2 1.41.59S14 1.45 14 2v2h-2V2H2v18h10v-2h2v2c0 .55-.2 1.02-.59 1.41S12.55 22 12 22zm5.71-3.5c.19-.19.29-.43.29-.71s-.1-.52-.29-.71-.43-.29-.71-.29-.52.1-.71.29-.29.43-.29.71.1.52.29.71.43.29.71.29.52-.1.71-.29m3.62-4.65L9.88 12.4c.2-.18.35-.4.46-.64s.16-.5.16-.76-.05-.52-.16-.76-.26-.45-.46-.64l1.45-1.45c.38.38.68.82.88 1.31s.3 1 .3 1.54-.1 1.05-.3 1.54-.49.93-.88 1.31m2.45 2.45-1.4-1.4c.52-.52.92-1.11 1.2-1.78s.43-1.38.43-2.13-.14-1.46-.43-2.13-.68-1.26-1.2-1.78l1.4-1.4q1.08 1.05 1.65 2.43c.57 1.38.58 1.88.58 2.88s-.19 1.96-.58 2.88-.93 1.73-1.65 2.43"
        })
    });
/* harmony default export */ var mobileIcon = (MobileIcon);

// EXTERNAL MODULE: ./src/components/shared/affiliateOfferUrl/style.module.scss
var style_module = __webpack_require__(24027);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/components/shared/offerVertical/index.tsx
var offerVertical = __webpack_require__(71466);
;// CONCATENATED MODULE: ./src/components/shared/affiliateOfferUrl/index.tsx








function AffiliateOfferUrl({ className , children , customHref , offer , target , style , zone , template ="default"  }) {
    const { 0: listId , 1: setListId  } = (0,react.useState)(null);
    const { category , locale  } = (0,useDomainContext/* useDomainContext */.w)();
    const clickToCallLabel = (0,offerVertical/* getText */.Q)(category?.config?.clickToCallLabel, locale);
    (0,react.useEffect)(()=>{
        setListId((0,cookies/* getAffiliateListId */.Hf)());
    }, [
        cookies/* getAffiliateListId */.Hf
    ]);
    const queryParams = [];
    if (listId) {
        queryParams.push(`id=${listId}`);
    }
    if (offer?.category?.id) {
        queryParams.push(`categoryId=${offer.category.id.toString()}`);
    }
    if (zone) {
        queryParams.push(`zone=${zone}`);
    }
    let innerLinkContent = children;
    if (customHref) {
        if (template === "default") {
            innerLinkContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: children
            });
        } else {
            innerLinkContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (style_module_default()).clickToCallWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (style_module_default()).svgWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobileIcon, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (style_module_default()).textWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (style_module_default()).clickToCall,
                                    children: clickToCallLabel || "Click to Call"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (style_module_default()).phoneNumberClick,
                                    children: children
                                })
                            ]
                        })
                    ]
                })
            });
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        style: style,
        target: target,
        className: className ?? "",
        rel: "noreferrer",
        href: customHref ?? `/offer/${offer?.slug ?? ""}?${queryParams.join("&")}`,
        onClick: ()=>{
            if (customHref) {
                void (0,api/* callEvent */.dr)({
                    event: "Call",
                    phoneNumber: customHref?.split("tel:")[1] ?? ""
                });
            }
        },
        children: innerLinkContent
    });
}


/***/ }),

/***/ 97943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Facebook() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#4780c0",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_32_1514",
                style: {
                    maskType: "alpha"
                },
                width: "18",
                height: "15",
                x: "26",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26.121 10H43.208V25H26.121z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_32_1514)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M33.155 24.318h3.04v-6.881h2.12l.232-2.301h-2.353v-1.31c0-.548.116-.756.7-.756h1.653v-2.388h-2.115c-2.268 0-3.289.898-3.289 2.618v1.841h-1.586v2.329h1.586l.012 6.848z"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Facebook);


/***/ }),

/***/ 22371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Twitter() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#35a9ff",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                style: {
                    maskType: "alpha"
                },
                width: "18",
                height: "15",
                x: "26",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26.025 10H43.111999999999995V25H26.025z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_32_1513)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M26.01 22.15a10.97 10.97 0 005.135 1.374 11.06 11.06 0 005.201-1.167c1.58-.8 2.878-1.965 3.755-3.369.877-1.403 1.298-2.99 1.217-4.59a6.803 6.803 0 001.779-1.595 7.52 7.52 0 01-2.012.484c.736-.38 1.289-.984 1.553-1.697a7.756 7.756 0 01-2.22.75 3.665 3.665 0 00-1.983-.933c-.76-.111-1.54.002-2.22.32-.68.32-1.22.826-1.537 1.442a2.725 2.725 0 00-.218 1.966 11.02 11.02 0 01-3.997-.927 9.796 9.796 0 01-3.218-2.277 2.746 2.746 0 00-.38 2.234c.203.76.727 1.424 1.467 1.856a3.872 3.872 0 01-1.553-.381c-.01.715.265 1.41.777 1.966s1.228.939 2.026 1.081a4.064 4.064 0 01-1.553.055 3.1 3.1 0 001.24 1.525 3.804 3.804 0 002.022.602 7.394 7.394 0 01-2.492 1.114 7.931 7.931 0 01-2.79.168z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_32_1513",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H17.048V12.164H0z",
                        transform: "translate(26.025 11.364)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Twitter);


/***/ }),

/***/ 43808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Pinterest() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#e60023",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_32_1516",
                style: {
                    maskType: "alpha"
                },
                width: "19",
                height: "15",
                x: "25",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M25.93 10H43.016999999999996V25H25.93z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_32_1516)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M30.756 18.573a.327.327 0 00.382-.078.262.262 0 00.056-.117c.037-.14.129-.486.172-.631.043-.145.037-.263-.123-.436a2.15 2.15 0 01-.573-1.541c-.007-.505.1-1.005.314-1.47.214-.466.53-.887.929-1.239a4.177 4.177 0 011.392-.806 4.492 4.492 0 011.631-.244c2.33 0 3.607 1.29 3.607 3.01 0 2.262-1.104 4.172-2.75 4.172a1.46 1.46 0 01-.613-.103 1.331 1.331 0 01-.494-.343 1.168 1.168 0 01-.27-.509 1.1 1.1 0 01.014-.564c.26-.994.765-2.066.765-2.792.02-.15.005-.3-.045-.444a1.03 1.03 0 00-.244-.388 1.162 1.162 0 00-.4-.26 1.265 1.265 0 00-.483-.087c-.924 0-1.67.866-1.67 2.028-.006.428.088.853.277 1.245l-1.116 4.273a8.05 8.05 0 000 2.982c.004.02.014.038.03.053a.12.12 0 00.055.03.13.13 0 00.064 0 .12.12 0 00.055-.032 8.308 8.308 0 001.566-2.57c.104-.351.616-2.161.616-2.161.233.312.549.566.918.738.37.171.782.256 1.197.245 2.787 0 4.673-2.301 4.673-5.384 0-2.324-2.176-4.468-5.48-4.468-4.12 0-6.166 2.675-6.166 4.903-.056 1.34.505 2.542 1.714 2.988z"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Pinterest);


/***/ }),

/***/ 8281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Mobile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/oneElement/index.tsx
var oneElement = __webpack_require__(36895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/share/styles.module.scss
var styles_module = __webpack_require__(48378);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/shared/blogPost/sideWidget/mobile/share/Share.tsx



const Share = ({ shareList  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: shareList?.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: `cursor-pointer  ${(styles_module_default())[el.name]}`,
                onClick: ()=>{
                    window.open(el.link, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");
                    return false;
                },
                children: el.icon
            }, index))
    });
};
/* harmony default export */ var share_Share = (Share);

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/Facebook.tsx
var Facebook = __webpack_require__(97943);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/Twitter.tsx
var Twitter = __webpack_require__(22371);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/pinterest.tsx
var pinterest = __webpack_require__(43808);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx









function Mobile() {
    const { asPath  } = (0,router.useRouter)();
    const { blogPost , domain  } = (0,useDomainContext/* useDomainContext */.w)();
    const shareList = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook/* default */.Z, {}),
            link: `https://www.facebook.com/sharer/sharer.php?u=https://${domain.name}${asPath}`,
            name: "facebook"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter/* default */.Z, {}),
            link: `https://twitter.com/share?url=https://${domain.name}${asPath}`,
            name: "twitter"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(pinterest/* default */.Z, {}),
            link: `http://pinterest.com/pin/create/button/?url=https://${domain.name}${asPath}`,
            name: "pinterest"
        }, 
    ];
    const myList = [
        {
            title: "Contents",
            slug: "contents",
            content: (0,sharedUtils/* getMainTitlesNavigationFromBody */._H)(blogPost?.model.body)
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `   px-5 py-10  max-h-[80vh] flex flex-col justify-between `,
        children: [
            myList?.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(oneElement/* default */.Z, {
                    content: el.content
                }, index)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: `mt-4 text-sm font-bold`,
                        children: "Share"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `flex  gap-2 mt-3 justify-center  `,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(share_Share, {
                            shareList: shareList
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 36895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OneElement; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25086);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useModalContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67379);



function OneElement({ content  }) {
    const { setModal  } = (0,_hooks_useModalContext__WEBPACK_IMPORTED_MODULE_1__/* .useModal */ .d)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (content?.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().linksList)}      `,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "text-lg mt-8 mb-5 hidden lg:block ",
                    children: "Contents"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "max-h-[300px] overflow-y-auto",
                    children: content?.map((el, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: `
                                ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().bulletedListItem)} pl-5    
                                     pb-5  `,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: el?.link ?? "#",
                                dangerouslySetInnerHTML: {
                                    __html: el?.title
                                },
                                onClick: ()=>setModal({
                                        active: false,
                                        content: undefined
                                    }),
                                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().linkColor)}   block  cursor-pointer text-sm `
                            })
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 71466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ getText; },
/* harmony export */   "Z": function() { return /* binding */ OfferVertical; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81331);
/* harmony import */ var _styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75094);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76877);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _affiliateOfferUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25416);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88737);







const getText = (text, locale)=>{
    return text?.[locale] ?? text?.["en"] ?? "";
};
function OfferVertical({ offer , zone , displayLinkAndPhoneNumber , customStyle , template ="default"  }) {
    const phoneNumber = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .getPhoneNumber */ .ly)(offer);
    const { domain , category , locale  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_4__/* .useDomainContext */ .w)();
    const callToActionTitle = getText(category?.config?.offerVerticalCallToActionTitle, locale);
    const callToActionSubTitle = getText(category?.config?.offerVerticalCallToActionSubTitle, locale);
    const buttonFallbackText = getText(category?.config?.offerVerticalButtonFallbackText, locale);
    const freeEvaluationNote = getText(category?.config?.offerVerticalFreeEvaluationNote, locale);
    const phoneNumberMessage = offer?.attributes.phoneNumberMessage ? offer?.attributes.phoneNumberMessage : offer?.hiddenAttributes.phoneNumberMessage ? offer?.hiddenAttributes.phoneNumberMessage : "";
    const outerSectionStyle = {
        "--buttonBackgroundColor": `${customStyle?.buttonBgColor ?? (_styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().autumnGlory)}`
    };
    const clickToCallBorder = typeof domain.config?.clickToCallBorder === "string" ? domain.config.clickToCallBorder : undefined;
    const clickToCallBtnBackground = typeof domain.config?.clickToCallBtnBackground === "string" ? domain.config.clickToCallBtnBackground : undefined;
    const clickToCallBtnForground = typeof domain.config?.clickToCallBtnForground === "string" ? domain.config.clickToCallBtnForground : undefined;
    const clickToCallBtnShadow = typeof domain.config?.clickToCallBtnShadow === "string" ? `rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, ${domain.config.clickToCallBtnShadow} 0px 10px 15px -3px, ${domain.config.clickToCallBtnShadow} 0px 4px 6px -4px ` : undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().container)}  relative  mb-[30px] px-4 py-4   ${customStyle?.wrapperStyle ?? ""}`,
        style: outerSectionStyle,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col flex-wrap items-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: `w-40 mb-4 flex justify-center ${customStyle?.fixedHeight ? "h-20" : ""}`,
                    style: {
                        borderColor: (_styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().offerBorderColor)
                    },
                    children: offer.logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: offer.logo.fullPath,
                        alt: offer.title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        style: {
                                            fontSize: "24px",
                                            fontWeight: "700",
                                            lineHeight: 1.2
                                        },
                                        dangerouslySetInnerHTML: {
                                            __html: phoneNumberMessage || callToActionTitle || "Call Now & Discuss Options!"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().secondTitle),
                                    children: callToActionSubTitle || "Review offers and coverage eligibility instantly."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "order-3 flex flex-col mt-2 w-auto",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_affiliateOfferUrl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    zone: zone,
                                    template: template,
                                    className: `${!displayLinkAndPhoneNumber ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().link) : ""} ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().linkPageBuilderStyle)} ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btnStyle)} flex justify-center rounded-5 text-center px-[10px] py-[10px] text-[15px]`,
                                    offer: offer,
                                    customHref: phoneNumber ? `tel:${phoneNumber ?? ""}` : undefined,
                                    target: "_blank",
                                    style: {
                                        borderRadius: "12px",
                                        border: clickToCallBorder,
                                        background: clickToCallBtnBackground,
                                        color: clickToCallBtnForground,
                                        boxShadow: clickToCallBtnShadow
                                    },
                                    children: (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .formatPhoneNumber */ .un)(phoneNumber) || buttonFallbackText || "Let's Go"
                                }),
                                displayLinkAndPhoneNumber && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_affiliateOfferUrl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    zone: zone,
                                    className: `text-left lg:text-center py-3 rounded-lg ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().letGoStyle)}`,
                                    offer: offer,
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: buttonFallbackText || "Let's Go"
                                    })
                                })
                            ]
                        }),
                        (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .formatPhoneNumber */ .un)(phoneNumber) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                fontSize: "12px",
                                color: "#666",
                                textAlign: "center",
                                marginTop: "15px"
                            },
                            children: freeEvaluationNote || "Free Evaluation • No Obligation"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 76798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CheckIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CheckIcon({ className , fill  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        x: "0",
        y: "0",
        enableBackground: "new 0 0 32 26",
        version: "1.1",
        viewBox: "0 0 32 26",
        xmlSpace: "preserve",
        className: className ?? "",
        fill: fill,
        style: {
            fill: fill
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M27.1 0L25 2.2 10.7 17.4l-4.3-4.3L4.2 11 0 15.2l2.1 2.1 6.5 6.5 2.2 2.2 2.1-2.2L29.4 6.3l2.1-2.2L27.1 0z"
        })
    });
}


/***/ }),

/***/ 51132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DoubleArrowIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function DoubleArrowIcon({ className  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "21",
        height: "18",
        viewBox: "0 0 21 18",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: "1",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                fill: "#FFF",
                fillRule: "nonzero",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M2.51945229 0L-4.23661106e-13 2.48571429 6.66011737 9 -4.23661106e-13 15.5142857 2.51945229 18 11.7209302 9z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M11.7985221 0L9.27906977 2.48571429 15.9391871 9 9.27906977 15.5142857 11.7985221 18 21 9z"
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29540);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_2__);



function Button({ className ="" , children , onClick , icon , href , target , backgroundColor , style  }) {
    return href ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        style: {
            backgroundColor,
            ...style
        },
        target: target,
        href: href,
        className: `${(_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().button)} ${className ?? ""}`,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().inner),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().label),
                    children: children
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().icon),
                    children: icon
                })
            ]
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        style: {
            backgroundColor,
            ...style
        },
        onClick: onClick,
        className: `${(_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().button)}  ${className ?? ""}`,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().inner),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().label),
                    children: children
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().icon),
                    children: icon
                })
            ]
        })
    });
}


/***/ }),

/***/ 47462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ListingPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/layouts/index.tsx + 2 modules
var layouts = __webpack_require__(30171);
// EXTERNAL MODULE: ./src/components/svg/checkIcon.tsx
var checkIcon = __webpack_require__(76798);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/vpnpricecomparison/svg/fastIcon.tsx


function FastIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "72",
        height: "72",
        fill: "none",
        viewBox: "0 0 72 72",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FE895C",
                d: "M65.256 32.442c-1.832-.297-3.59 1.04-3.895 2.826-.763 5.277-3.206 10.11-7.101 13.903-5.803 5.652-13.67 7.956-21.23 6.916l-4.43 5.947c2.596.67 5.194.966 7.79.966 8.172 0 16.42-3.049 22.68-9.144 4.964-4.834 8.096-10.931 9.09-17.697.304-1.858-1.072-3.494-2.904-3.717zM64.83 3.786c-1.871 0-3.37 1.515-3.37 3.407v4.846l-2.697-2.725a31.145 31.145 0 00-44.426 0C6.245 17.49 3.545 29.076 6.169 39.6l5.77-8.026c.073-6.36 2.47-12.645 7.19-17.49 9.666-9.767 25.323-9.767 34.913 0l2.697 2.725h-4.796c-1.872 0-3.371 1.515-3.371 3.407 0 1.894 1.5 3.408 3.371 3.408h12.888c1.872 0 3.37-1.514 3.37-3.408V7.193c0-1.892-1.498-3.407-3.371-3.407z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FE895C",
                d: "M35.757 14.4c-1.975 0-3.555 1.477-3.555 3.322V31.6c0 1.476 1.026 2.806 2.608 3.175l10.902 2.878c.317.074.634.148.95.148 1.58 0 3.002-.96 3.398-2.436.552-1.773-.553-3.618-2.45-4.06l-8.298-2.214V17.72c0-1.844-1.577-3.32-3.553-3.32h-.002zM28.27 45.612h-5.908l1.764-12.652c.308-2.17-2.53-3.219-3.834-1.498L3.798 53.697c-.997 1.348 0 3.294 1.686 3.294h5.91L9.63 69.643c-.306 2.17 2.53 3.218 3.834 1.497l16.493-22.31c1.075-1.347.078-3.219-1.687-3.219z"
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/vpnpricecomparison/svg/hideIcon.tsx
var hideIcon = __webpack_require__(76837);
;// CONCATENATED MODULE: ./src/components/vpnpricecomparison/svg/mapPinIcon.tsx


function MapPinIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "72",
        height: "72",
        fill: "none",
        viewBox: "0 0 72 72",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FE895C",
                d: "M46.8 25.2c0-6.12-4.68-10.8-10.8-10.8-6.12 0-10.8 4.68-10.8 10.8C25.2 31.32 29.88 36 36 36c6.12 0 10.8-4.68 10.8-10.8zm-14.4 0c0-2.16 1.44-3.6 3.6-3.6s3.6 1.44 3.6 3.6-1.44 3.6-3.6 3.6-3.6-1.44-3.6-3.6z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FE895C",
                d: "M42.84 64.8C49.32 54.72 61.2 34.92 61.2 25.2 61.2 11.16 50.04 0 36 0S10.8 11.16 10.8 25.2c0 9.72 11.88 29.52 18.36 39.6H0V72h72v-7.2H42.84zM36 7.2c10.08 0 18 7.92 18 18 0 6.84-10.08 24.48-18 36.72-7.92-12.24-18-29.88-18-36.72 0-10.08 7.92-18 18-18z"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/vpnpricecomparison/svg/performanceIcon.tsx


function PerformanceIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "72",
        height: "72",
        fill: "none",
        viewBox: "0 0 72 72",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FF814F",
                d: "M17.904 33.37c1.193-.59 2.377-1.18 3.57-1.778.463-.235.932-.455 1.396-.697a13.136 13.136 0 003.517-2.738c2.146-2.377 3.394-5.342 3.565-8.527.06-1.21.015-2.436.015-3.655v-4.138c0-1.09-.832-2.338-1.98-2.55-2.093-.392-4.125-.93-6.105-1.74.217.09.433.182.648.264a27.563 27.563 0 01-4.619-2.442c-.755-.492-1.971-.492-2.717 0a27.477 27.477 0 01-4.619 2.444c.216-.092.431-.183.646-.265-1.97.809-4.011 1.347-6.104 1.739-.562.107-1.063.522-1.4.945-.363.462-.579 1.008-.579 1.605 0 2.407-.008 4.812 0 7.218.008 2.792.885 5.651 2.595 7.891 1.03 1.355 2.193 2.482 3.627 3.427.569.372 1.169.674 1.776.977l4.058 2.02c.646.325 1.362.461 2.077.264.625-.166 1.302-.643 1.61-1.218.647-1.203.377-2.957-.97-3.624-.978-.483-1.964-.976-2.94-1.46-1.178-.589-2.387-1.127-3.449-1.922.185.137.361.273.546.417a11.583 11.583 0 01-2.04-1.998c.14.181.277.357.423.538a11.148 11.148 0 01-1.438-2.437c.093.213.184.424.268.636a11.03 11.03 0 01-.753-2.747c.03.234.062.47.099.704-.146-1.098-.1-2.217-.1-3.322v-5.355c-.661.848-1.317 1.703-1.979 2.55 4.043-.764 7.936-2.194 11.371-4.457h-2.717c3.433 2.264 7.328 3.685 11.37 4.457-.663-.847-1.318-1.702-1.979-2.55v6.778c0 .636-.015 1.271-.1 1.907.03-.234.062-.47.1-.704-.131.945-.386 1.86-.755 2.747.093-.213.186-.425.27-.636-.378.87-.855 1.687-1.44 2.435.14-.181.278-.355.423-.536a11.214 11.214 0 01-2.04 1.998c.187-.137.363-.273.548-.417-1.064.787-2.263 1.333-3.45 1.922-.977.483-1.963.976-2.94 1.46-1.263.628-1.725 2.474-.97 3.624.808 1.263 2.317 1.612 3.665.945zm25.58-1.741c-.847 1.68-1.701 3.352-2.549 5.031l-4.063 8.035c-.316.62-.623 1.24-.939 1.854-.322.643-.47 1.333-.27 2.043.17.612.656 1.279 1.24 1.58 1.217.636 3.018.373 3.688-.952.846-1.679 1.7-3.351 2.548-5.032l4.064-8.035c.316-.62.623-1.24.94-1.852.323-.643.47-1.333.27-2.043-.171-.614-.655-1.279-1.24-1.581-1.225-.636-3.019-.372-3.688.953l-.002-.001zM64.39 50.136h4.287c1.411 0 2.756-1.219 2.696-2.65-.062-1.436-1.186-2.647-2.695-2.647H64.39c-1.409 0-2.756 1.219-2.694 2.648.062 1.438 1.186 2.649 2.694 2.649zm-60.067 0H8.61c1.41 0 2.756-1.219 2.696-2.65-.062-1.436-1.186-2.647-2.696-2.647H4.324c-1.41 0-2.756 1.219-2.694 2.648.068 1.438 1.186 2.649 2.694 2.649zM57.418 30.75c1.246-1.247 2.494-2.495 3.74-3.75.986-.993 1.079-2.77 0-3.747-1.07-.961-2.756-1.059-3.81 0a1215.759 1215.759 0 00-3.742 3.753c-.986.992-1.077 2.77 0 3.744 1.07.961 2.756 1.06 3.812 0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FF814F",
                d: "M37.911 51.883c0 .175-.015.348-.03.522.03-.234.061-.468.098-.704a4.308 4.308 0 01-.291 1.075c.093-.211.184-.424.268-.636-.146.333-.33.643-.553.94.14-.184.277-.357.423-.538-.231.279-.485.537-.77.756.186-.137.362-.273.547-.416a4.4 4.4 0 01-.854.492c.215-.092.43-.181.646-.264-.347.143-.7.233-1.077.287.237-.03.476-.062.714-.1a4.728 4.728 0 01-1.046 0c.239.032.477.063.716.1a4.852 4.852 0 01-1.077-.288c.215.091.43.181.646.265a4.307 4.307 0 01-.855-.492c.186.137.362.272.547.416a4.195 4.195 0 01-.77-.757c.139.182.278.357.424.538a4.565 4.565 0 01-.555-.939c.093.212.186.425.27.636a4.696 4.696 0 01-.293-1.075c.03.236.062.47.1.704a4.69 4.69 0 010-1.043c-.03.232-.061.468-.1.704.054-.372.146-.727.293-1.076-.093.212-.186.425-.27.635.146-.331.332-.641.555-.937-.14.181-.279.356-.425.537a4.87 4.87 0 01.77-.756c-.185.135-.36.271-.546.416.27-.197.555-.363.855-.492-.217.09-.43.181-.646.264a4.44 4.44 0 011.077-.287c-.239.03-.477.062-.716.1a4.728 4.728 0 011.046 0c-.238-.032-.477-.063-.714-.1.369.053.73.152 1.077.288-.217-.091-.431-.181-.646-.265.306.137.592.295.852.492a38.95 38.95 0 01-.545-.416c.292.219.547.476.77.756-.14-.18-.278-.356-.423-.537.223.294.407.604.553.937-.093-.21-.184-.423-.268-.635.138.349.239.704.291 1.076-.03-.236-.062-.47-.099-.704.016.173.031.347.031.52.016 1.386 1.225 2.718 2.694 2.65 1.448-.062 2.71-1.166 2.694-2.65-.016-1.307-.385-2.678-1.155-3.76-.893-1.24-2.024-2.101-3.472-2.64-2.463-.908-5.572-.083-7.243 1.907-1.017 1.218-1.57 2.55-1.71 4.123-.114 1.302.27 2.724.947 3.837.647 1.066 1.64 2.035 2.787 2.565 1.463.672 2.956.862 4.542.558 1.339-.256 2.71-1.065 3.58-2.102 1.085-1.294 1.7-2.8 1.724-4.487.015-1.384-1.256-2.708-2.694-2.648-1.471.069-2.672 1.166-2.694 2.648z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FF814F",
                d: "M3.685 35.896A33.32 33.32 0 001.69 49.5c.28 4.411 1.402 8.655 3.296 12.657.415.878.87 1.733 1.364 2.566.414.703.83 1.49 1.56 1.914.44.248.872.347 1.38.362h54.415c.508-.015.931-.105 1.37-.362.762-.439 1.193-1.294 1.624-2.028 4.418-7.528 5.727-16.577 3.719-25.035-1.547-6.538-5.174-12.628-10.184-17.182-5.013-4.563-11.417-7.725-18.206-8.723-1.832-.273-3.674-.44-5.528-.447-1.455 0-2.695 1.217-2.695 2.648v4.214c0 1.384 1.24 2.708 2.695 2.647 1.462-.06 2.694-1.164 2.694-2.647V15.87L36.5 18.517c1.431 0 2.855.091 4.272.28-.239-.03-.477-.06-.716-.097a32.562 32.562 0 018.192 2.185c-.217-.09-.433-.181-.648-.263a32.483 32.483 0 017.167 4.107c-.186-.136-.361-.272-.547-.417a32.72 32.72 0 015.836 5.728c-.14-.182-.278-.355-.423-.537a32.106 32.106 0 014.188 7.037 19.922 19.922 0 01-.27-.635 31.718 31.718 0 012.232 8.041c-.03-.234-.062-.47-.1-.703a31.902 31.902 0 010 8.489c.03-.236.061-.47.1-.704a31.428 31.428 0 01-2.232 8.043c.093-.212.184-.424.27-.635a32.362 32.362 0 01-2.434 4.577c.778-.439 1.547-.879 2.325-1.31H11.476c-.709 0-1.417-.015-2.124 0H9.26c.777.439 1.547.877 2.325 1.31a32.118 32.118 0 01-2.433-4.577c.093.21.186.423.27.635a31.508 31.508 0 01-2.233-8.044c.031.235.062.47.1.705a32.032 32.032 0 010-8.49c-.032.235-.063.47-.1.704a31.85 31.85 0 011.67-6.643c.232-.612.054-1.49-.27-2.043-.322-.552-.969-1.074-1.609-1.217-.693-.151-1.462-.12-2.077.264-.594.394-.963.908-1.217 1.589z"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/vpnpricecomparison/svg/riskIcon.tsx


function RiskIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "72",
        height: "73",
        fill: "none",
        viewBox: "0 0 72 73",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FF783E",
                stroke: "#FF6E24",
                strokeWidth: "0.5",
                d: "M12.08 61.971c-10.512-9.914-13.92-25.253-8.599-38.7C8.803 9.825 21.778.997 36.216 1c4.61-.005 9.172.905 13.43 2.677a35.574 35.574 0 0119.101 19.145 35.002 35.002 0 01-3.197 32.871 36.138 36.138 0 01-4.356 5.343.285.285 0 01-.401 0l-1.76-1.758a.28.28 0 01-.098-.063L54.03 54.3a.287.287 0 010-.402l2.567-2.578c.11-.11.29-.11.4 0l3.788 3.795a31.105 31.105 0 002.207-3.273A30.665 30.665 0 0067.2 36.91h-5.215a.287.287 0 01-.286-.286v-3.636c0-.158.128-.287.286-.287h5.021a30.92 30.92 0 00-2.706-9.52 31.304 31.304 0 00-5.627-8.254l-3.359 3.365a.285.285 0 01-.4 0l-2.575-2.578a.287.287 0 010-.402l3.237-3.245a30.996 30.996 0 00-8.523-4.88c-3.008-1.15-5.002-1.81-8.368-1.941v4.594a.288.288 0 01-.286.286h-3.646a.288.288 0 01-.286-.286v-4.48c-3.34.316-7.765 1.149-10.71 2.464a31.08 31.08 0 00-8.265 5.34l3.364 3.372c.11.11.11.29 0 .4l-2.572 2.582a.287.287 0 01-.402 0l-3.323-3.334a31.057 31.057 0 00-5.16 8.535 31.47 31.47 0 00-2.131 9.723h5.159c.156 0 .286.128.286.286v3.652c0 .16-.128.288-.286.288h-5.16a31.034 31.034 0 004.53 13.955 30.064 30.064 0 002.452 3.446l4.15-4.158c.11-.11.289-.11.4 0l2.573 2.578c.11.111.11.29 0 .402-2.321 2.348-4.613 4.629-6.906 7.069a.271.271 0 01-.197.084.28.28 0 01-.199-.084l.013.012h-.002z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FF783E",
                d: "M39.369 41.048L22.003 52.589a.3.3 0 01-.403-.032l-1.743-1.803a.316.316 0 010-.412L32.832 34.53c1.872-2.102 3.912-2.54 5.554-2.035a4.55 4.55 0 012.1 1.37 4.786 4.786 0 011.118 2.254c.335 1.69-.241 3.537-2.235 4.94v-.011zM27.08 68.628a58.939 58.939 0 002.477 3.39l-.052.356a15.726 15.726 0 01-3.454.604l-.323-.26-.208-.408-.575-1.094a24.505 24.505 0 01-.72-1.575h-1.11l.121 3.146H19.78l.172-3.098-.172-7.442h5.286a4.408 4.408 0 012.878.839 2.959 2.959 0 011.018 2.42 3.314 3.314 0 01-.495 1.745 4.476 4.476 0 01-1.363 1.4l-.024-.021v-.002zm-1.773-2.817a1.255 1.255 0 00-.35-.944 1.794 1.794 0 00-1.153-.349l-.62.044-.07 2.725 1.255.066c.293-.118.54-.318.708-.573.163-.29.24-.615.224-.942l.006-.029v.002zm8.745 3.548l.14 3.423h-3.455l.172-3.096-.172-7.447h3.51l-.195 7.12zm6.64-7.315a9.559 9.559 0 013.236.572l-.576 2.655-.485.196a7.803 7.803 0 00-1.426-.67 3.619 3.619 0 00-1.152-.246c-.219-.011-.438.04-.627.147a.44.44 0 00-.23.391c.003.23.137.439.35.547.37.219.753.411 1.152.579.542.225 1.07.479 1.583.756.427.25.795.577 1.083.965.322.44.485.968.466 1.503a3.03 3.03 0 01-.576 1.806c-.4.543-.947.977-1.584 1.252a6.027 6.027 0 01-2.474.476 12.045 12.045 0 01-3.685-.621l.5-2.835.34-.197a7.09 7.09 0 001.727.905 4.5 4.5 0 001.503.338c.244.019.488-.036.696-.157a.455.455 0 00.22-.382.682.682 0 00-.375-.579 7.678 7.678 0 00-1.19-.577 14.766 14.766 0 01-1.591-.73 3.403 3.403 0 01-1.058-.965 2.51 2.51 0 01-.445-1.505c-.01-.657.191-1.305.576-1.853a3.998 3.998 0 011.636-1.293 5.777 5.777 0 012.395-.474l.009-.005h.002zm11.474 5.184a69.51 69.51 0 003.616 4.872l-.052.355c-1.14.248-2.293.43-3.454.545l-.38-.196a302.077 302.077 0 01-2.879-4.84l-.035 1.417.138 3.423h-3.454l.172-3.096-.172-7.447h3.512l-.12 4.398 2.127-3.27.577-1.139h3.65l-3.27 4.988.023-.01h.001z"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/lib/vpnpricecomparison/vpnFeatures.ts





const vpnFeatures = [
    {
        title: "Hide Your IP & Protect Your Privacy",
        icon: (0,hideIcon/* default */.Z)()
    },
    {
        title: "Access GEO-Blocked Websites & Apps",
        icon: MapPinIcon()
    },
    {
        title: "Fast Streaming For Netflix, Hulu, & More",
        icon: FastIcon()
    },
    {
        title: "Fastest VPNs For Browsing, Gaming and Torrents",
        icon: PerformanceIcon()
    },
    {
        title: "Totally Risk Free VPN Companies",
        icon: RiskIcon()
    }, 
];

// EXTERNAL MODULE: ./src/components/vpnpricecomparison/listingBlock/listingBlock.module.scss
var listingBlock_module = __webpack_require__(82471);
var listingBlock_module_default = /*#__PURE__*/__webpack_require__.n(listingBlock_module);
// EXTERNAL MODULE: ./src/components/vpnpricecomparison/button/index.tsx
var vpnpricecomparison_button = __webpack_require__(109);
// EXTERNAL MODULE: ./src/components/svg/doubleArrowIcon.tsx
var doubleArrowIcon = __webpack_require__(51132);
// EXTERNAL MODULE: ./src/components/vpnpricecomparison/listingBlock/circularProgress.module.scss
var circularProgress_module = __webpack_require__(89755);
var circularProgress_module_default = /*#__PURE__*/__webpack_require__.n(circularProgress_module);
;// CONCATENATED MODULE: ./src/components/vpnpricecomparison/listingBlock/circularProgress.tsx



function CircularProgress({ scoreValue , scoreColor  }) {
    const rightSideStyle = {
        borderColor: scoreColor
    };
    const pieStyle = {};
    if (scoreValue * 10 <= 50) {
        rightSideStyle["display"] = "none";
    } else {
        rightSideStyle["transform"] = "rotate(180deg)";
        pieStyle["clip"] = "rect(auto, auto, auto, auto)";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `${(circularProgress_module_default())["set-size"]} ${(circularProgress_module_default())["charts-container"]}`,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: `${(circularProgress_module_default())["pie-wrapper"]}`,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: `${(circularProgress_module_default()).label}`,
                    children: scoreValue
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: `${(circularProgress_module_default()).pie}`,
                    style: pieStyle,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: `${(circularProgress_module_default())["left-side"]} ${(circularProgress_module_default())["half-circle"]}`,
                            style: {
                                borderColor: scoreColor,
                                transform: `rotate(${scoreValue * 10 * 3.6}deg)`
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: `${(circularProgress_module_default())["right-side"]} ${(circularProgress_module_default())["half-circle"]}`,
                            style: rightSideStyle
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/components/shared/affiliateOfferUrl/index.tsx + 1 modules
var affiliateOfferUrl = __webpack_require__(25416);
;// CONCATENATED MODULE: ./src/components/vpnpricecomparison/listingBlock/discountIcon.tsx


function DiscountIcon({ fill , classes  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
        className: classes,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "16",
            height: "24",
            viewBox: "0 0 16 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.1836 0.912207C10.1836 0.912207 9.35839 4.49712 11.4212 7.70121C13.4834 10.9053 20.5258 17.2189 10.5644 23.0878C10.5644 23.0878 12.674 20.0896 11.6113 18.0435C10.5485 15.9972 8.26471 14.4745 8.6449 11.2704C8.6449 11.2704 5.63166 12.5239 6.96374 18.2016C6.96374 18.2016 5.26669 17.5832 4.55234 15.9098C4.55234 15.9098 3.4975 19.193 5.43293 23.0322C5.43293 23.0322 -4.7975 18.1533 3.44993 8.67676C3.44993 8.67676 3.6242 11.7698 4.84596 12.6266C4.84596 12.6266 2.83133 4.25151 10.1834 0.912079L10.1836 0.912207Z",
                fill: fill
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/vpnpricecomparison/listingBlock/index.tsx









function ListingBlock({ zone , index , item  }) {
    const discountValue = item.hiddenAttributes.discountValue;
    const scoreValue = item.hiddenAttributes.scoreValue ?? "6.3";
    const scoreMsg = item.hiddenAttributes.scoreMsg ?? "Super!";
    const scoreColor = item.hiddenAttributes?.scoreColor ?? "#83B855";
    const promoCode = item.hiddenAttributes?.promoCode ?? "";
    const discountColor = item.hiddenAttributes?.discountColor ?? "#83B855";
    const discount = discountValue ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `${(listingBlock_module_default()).saving} flex items-center justify-start md:justify-center`,
        style: {
            color: discountColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountIcon, {
                fill: discountColor,
                classes: `${(listingBlock_module_default()).savingIcon} mr-2`
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Discount"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: discountValue
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "%"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    const devicesList = item.attributes.devices?.split(",").map((device)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: `${(listingBlock_module_default()).device} ${(listingBlock_module_default())[device]}`,
            children: device
        }, device));
    let first3Features = [];
    let restFeatures = [];
    if (Array.isArray(item.features) && item.features.length) {
        first3Features = item.features.slice(0, 3);
        restFeatures = item.features.slice(3);
    }
    const devicesListElement = devicesList && devicesList.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "devices flex items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (listingBlock_module_default()).devicesTitle,
                children: "Available on:"
            }),
            devicesList
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `${(listingBlock_module_default())["listing-block-wrapper"]}`,
        children: [
            index === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: `${(listingBlock_module_default()).service__badge} ${(listingBlock_module_default()).badge} ${(listingBlock_module_default()).badge_pos}`,
                children: [
                    "Best VPN of ",
                    new Date().getFullYear()
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `${(listingBlock_module_default())["listing-block"]} ${(listingBlock_module_default())[`listing-block-${index}`]}`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `${(listingBlock_module_default()).inner}`,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:flex md:items-center md:justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (listingBlock_module_default()).number,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: index + 1
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (listingBlock_module_default()).logoContentWrapper,
                                children: [
                                    item.logo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (listingBlock_module_default()).image,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "h-7 w-auto",
                                            src: item.logo.fullPath,
                                            alt: item.description
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (listingBlock_module_default()).content,
                                        children: [
                                            index === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                // style={{ color: color ?? colors.melon }}
                                                className: (listingBlock_module_default()).description,
                                                children: item.description
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (listingBlock_module_default()).features,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: first3Features.map((feature, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkIcon/* default */.Z, {
                                                                        fill: "#000"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: feature
                                                                    })
                                                                ]
                                                            }, index))
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "hidden",
                                                        children: restFeatures.map((feature, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkIcon/* default */.Z, {
                                                                        fill: "#000"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: feature
                                                                    })
                                                                ]
                                                            }, index))
                                                    })
                                                ]
                                            }),
                                            devicesListElement
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: `${(listingBlock_module_default()).scoreColumn} flex flex-row md:flex-col`,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: `${(listingBlock_module_default()).score} flex items-center w-1/2 md:w-full`,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (listingBlock_module_default()).scoreValue,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress, {
                                                    scoreValue: parseFloat(scoreValue),
                                                    scoreColor: scoreColor
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: `${(listingBlock_module_default()).scoreMsg} text-sm capitalize`,
                                                children: scoreMsg
                                            })
                                        ]
                                    }),
                                    promoCode && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: `${(listingBlock_module_default()).promoZone}  w-1/2 md:w-full text-xs md:text-base text-center`,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-center",
                                                children: "For extra discount"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: `${(listingBlock_module_default()).promo} p-1.5 mx-2  md:mx-0`,
                                                children: promoCode
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (listingBlock_module_default()).meta,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: `${(listingBlock_module_default()).discountBlock} text-center text-xs md:text-base`,
                                        children: discount
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(vpnpricecomparison_button/* Button */.z, {
                                            className: `${(listingBlock_module_default()).button} font-medium`,
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(doubleArrowIcon/* default */.Z, {}),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(affiliateOfferUrl/* default */.Z, {
                                                zone: zone,
                                                offer: item,
                                                target: "_blank",
                                                className: (listingBlock_module_default()).link,
                                                children: "Visit Website"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/vpnpricecomparison/listing/index.tsx



function Listing({ listing , zone  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: listing?.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ListingBlock, {
                zone: zone,
                item: item,
                index: index
            }, item.id))
    });
}

// EXTERNAL MODULE: ./src/styles/variables/vpnpricecomparisonVariables.module.scss
var vpnpricecomparisonVariables_module = __webpack_require__(75735);
var vpnpricecomparisonVariables_module_default = /*#__PURE__*/__webpack_require__.n(vpnpricecomparisonVariables_module);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/lib/shared/config.ts
var config = __webpack_require__(98218);
;// CONCATENATED MODULE: ./src/components/vpnpricecomparison/listingPage/index.tsx









function ListingPage(props) {
    const { type  } = props;
    const { visitDetails , comparisonListing , categoryListing , formattedTitle  } = (0,useDomainContext/* useDomainContext */.w)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* VpnPriceComparisonWrapper */.S, {
        backgroundColor: categoryListing?.hiddenAttributes?.color ?? "#FFAC00",
        withFlag: type === "comparison",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "details",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col md:flex-row flex-wrap lg:justify-between lg:items-center mb-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:w-1/2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-xl md:text-2xl lg:text-3xl font-bold",
                                dangerouslySetInnerHTML: {
                                    __html: type === "listing" ? categoryListing?.pageTitle ?? "" : formattedTitle ?? `Best VPN Companies For ${visitDetails?.country}`
                                }
                            }),
                            type === "listing" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "text-sm md:text-sm mt-3",
                                children: categoryListing?.features.map((feature, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "flex font-light items-start mb-2 ",
                                        style: {
                                            color: (vpnpricecomparisonVariables_module_default()).melon
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(checkIcon/* default */.Z, {
                                                className: "w-3 h-3 mr-2 mt-1.5 fill-current"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    color: (vpnpricecomparisonVariables_module_default()).slightlyBlack
                                                },
                                                children: feature
                                            })
                                        ]
                                    }, index))
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm md:text-base font-light mt-4",
                                children: "For Limited Time, We Managed to Secure Exclusive Offers & Deals For the Top VPN Providers. Act Now, Here are the Best Available Deals:"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Listing, {
                    zone: type === "listing" ? config/* affiliateOfferZones.LISTING_PAGE */.ZR.LISTING_PAGE : config/* affiliateOfferZones.COMPARISON_PAGE */.ZR.COMPARISON_PAGE,
                    listing: type === "listing" ? categoryListing?.offers : comparisonListing?.offers
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "features horizontal-scroll lg:overflow-auto mt-7 h-40 lg:h-56 -m-4 lg:m-0 px-4 lg:px-0 lg:mt-6",
                    children: vpnFeatures.map((feature, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                borderColor: (vpnpricecomparisonVariables_module_default()).pinkishGrey
                            },
                            className: "border text-center horizontal-scroll-child lg:flex-auto flex flex-col justify-center items-center w-4/5 md:w-2/5 mr-4 last:mr-0 py-5 lg:px-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "children:w-10 children:h-10",
                                    children: feature.icon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "mt-5 text-sm lg:text-base w-full",
                                    children: feature.title
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 76837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HideIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function HideIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "72",
        height: "72",
        fill: "none",
        viewBox: "0 0 72 72",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "#FE895C",
            d: "M13.964 24.6a69.64 69.64 0 00-12.52 10.587 1.666 1.666 0 000 2.264c3.826 4.142 18.074 18.193 35.06 18.193a33.21 33.21 0 007.597-.907l-6.114-6.114c-.492.057-.987.086-1.483.086a12.385 12.385 0 01-12.386-12.386c0-.495.03-.99.087-1.483L13.965 24.6zM71.557 37.451a1.666 1.666 0 000-2.264c-3.827-4.142-18.075-18.185-35.053-18.185a35.376 35.376 0 00-12.407 2.387L8.685 3.977l-4.53 4.53L64.318 68.67l4.53-4.53L55.11 50.402a68.194 68.194 0 0016.447-12.95zm-27.885 1.513a7.633 7.633 0 00-9.815-9.815l-3.537-3.538A12.356 12.356 0 0147.21 42.504l-3.539-3.539z"
        })
    });
}


/***/ }),

/***/ 24027:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"clickToCallWrapper":"style_clickToCallWrapper__VwAdQ","textWrapper":"style_textWrapper__4UGtd","svgWrapper":"style_svgWrapper__hIySB","clickToCall":"style_clickToCall__9Mqb6","phoneNumberClick":"style_phoneNumberClick__xFVNS"};

/***/ }),

/***/ 48378:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"facebook":"styles_facebook__EYfOu","twitter":"styles_twitter__47r59","pintrest":"styles_pintrest__w6OTr"};

/***/ }),

/***/ 25086:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"linkColor":"style_linkColor__aZ9m3","linksList":"style_linksList__xLuOw","bulletedListItem":"style_bulletedListItem__H1JoX"};

/***/ }),

/***/ 76877:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__wOf18","title":"style_title__cWvij","linkPageBuilderStyle":"style_linkPageBuilderStyle__CqdI2","letGoStyle":"style_letGoStyle__5KJJo","link":"style_link__LGb3m","secondTitle":"style_secondTitle__6rLsc","btnStyle":"style_btnStyle__6X7g_"};

/***/ }),

/***/ 29540:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"button_button__z3xac","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","inner":"button_inner__vLsSW","label":"button_label__4HLaz","icon":"button_icon__NXAmP"};

/***/ }),

/***/ 89755:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"set-size":"circularProgress_set-size__zhHbO","charts-container":"circularProgress_charts-container__uEqIN","pie-wrapper":"circularProgress_pie-wrapper__TdLG_","pie":"circularProgress_pie___z8sl","half-circle":"circularProgress_half-circle__P9kVU","label":"circularProgress_label__PGH__","pie-wrapper--solid":"circularProgress_pie-wrapper--solid__C42jN"};

/***/ }),

/***/ 82471:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"listingBlock_button__Xfxao","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","logoContentWrapper":"listingBlock_logoContentWrapper__uQQzw","content":"listingBlock_content__1B4Al","listing-block":"listingBlock_listing-block__R8pic","inner":"listingBlock_inner__dZGd6","background":"listingBlock_background__fRvlR","number":"listingBlock_number__NExKw","image":"listingBlock_image__yKgQm","btn-anim1":"listingBlock_btn-anim1__cAXM5","btn-anim2":"listingBlock_btn-anim2__WYtz3","btn-anim3":"listingBlock_btn-anim3__hI_h6","btn-anim4":"listingBlock_btn-anim4__68sCB","description":"listingBlock_description__dl7O5","logo":"listingBlock_logo__PXt1v","features":"listingBlock_features__Yzo1b","meta":"listingBlock_meta__vhiIa","saving":"listingBlock_saving__ZAZZd","price":"listingBlock_price__FYGvd","after":"listingBlock_after__QUaNy","before":"listingBlock_before__SKt2f","listing-block-0":"listingBlock_listing-block-0__Tm2Ob","listing-block-wrapper":"listingBlock_listing-block-wrapper__JeLes","service__badge":"listingBlock_service__badge__Ekfox","badge_pos":"listingBlock_badge_pos__OdLup","badge":"listingBlock_badge__39fDU","device":"listingBlock_device__0Litg","devicesTitle":"listingBlock_devicesTitle__582Gq","link":"listingBlock_link__uTORA","windows":"listingBlock_windows__odNjz","macos":"listingBlock_macos__2TjRF","linux":"listingBlock_linux__nfACQ","ios":"listingBlock_ios__8GlUg","android":"listingBlock_android__VfIzP","chrome":"listingBlock_chrome__UWnVo","firefox":"listingBlock_firefox__XsIBU","opera":"listingBlock_opera__TInR7","safari":"listingBlock_safari__xINqS","ie":"listingBlock_ie__Awwzw","edge":"listingBlock_edge__WZCdn","other":"listingBlock_other__esGVv","domainLink":"listingBlock_domainLink__9ljzB","savingIcon":"listingBlock_savingIcon__uAnSx","scoreColumn":"listingBlock_scoreColumn__nVT2Z","promo":"listingBlock_promo__9bZFc","promoZone":"listingBlock_promoZone__Vl5y9"};

/***/ }),

/***/ 81331:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"goGoGreen":"#008a7b","green":"#5bc1a4","bankVault":"#747474","autumnGlory":"#3ea636","offerBorderColor":"#e4e7eb"};

/***/ }),

/***/ 75735:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem"};

/***/ })

}]);